import { mylotusConstants } from "../constants/";
import { mylotusServices } from "services/mylotus.services";
import { loader, alert as customAlert } from "helpers";
import i18n from "i18n";

const defaultFailedText = "api_messages.SOMETHING_WENT_WRONG";

const addQuotaScratchGameMessage = "Add Quota scratch game success";

export const mylotusActions = {
  updateTransaction,
  addQuotaScratchGame
};

function updateTransaction(params, merchantProjectCode = "") {
  // console.log("mylotusActions.updateTransaction params:", params);
  return dispatch => {
    loader(dispatch, true);
    return mylotusServices
      .updateTransaction(params)
      .then(
        res => {
          if (res.status) {
            dispatch({
              type: mylotusConstants.EDIT_EARN_REPORT_SUCCESS,
              data: res.data
            });

            if (merchantProjectCode !== 'scratchtowin') {
              customAlert(
                dispatch,
                "success",
                i18n.t("warning_messages.transaction_was_updated")
              );
            }
          } else {
            if (!res.unAlert) {
              customAlert(
                dispatch,
                "error",
                i18n.t(`api_messages.${res.message.toString()}`)
              );
            }
          }
          return res;
        },
        error => {
          customAlert(dispatch, "error", i18n.t(defaultFailedText));
          return Promise.reject(error);
        }
      )
      .finally(() => {
        loader(dispatch, false);
      });
  };
}

function addQuotaScratchGame(params) {
  return dispatch => {
    loader(dispatch, true);
    return mylotusServices
      .addQuotaScratchGame(params)
      .then(
        res => {
          if (res.status) {
            dispatch({
              type: mylotusConstants.ADD_QUOTA_SUCCESS,
              data: res.data
            });

            customAlert(
              dispatch,
              "success",
              i18n.t(res.message || "api_messages.SUCCESS") +
                "\n and \n" +
                addQuotaScratchGameMessage
            );
          } else {
            if (!res.unAlert) {
              let errorMessage =
                res.message !== "" ? "\n (" + res.message + ")" : "";

              customAlert(
                dispatch,
                "error",
                i18n.t(defaultFailedText) + errorMessage
              );
            }
          }
          return res;
        },
        error => {
          customAlert(dispatch, "error", i18n.t(defaultFailedText));
          return Promise.reject(error);
        }
      )
      .finally(() => {
        loader(dispatch, false);
      });
  };
}
